// @mui
import {
  Table,
  TableCell,
  TableRow,
  TableBody,
  Typography,
} from "@mui/material";
import Iconify from "../../components/iconify";
import OptionPreview from "./OptionPreview";
import DeleteDialog from "./DeleteDialog";
import { useState } from "react";
// ----------------------------------------------------------------------

export default function OptionsTable(props) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [questionIndex, setQuestionIndex] = useState(null);
  return (
    <>
      {props.options.length === 0 ? (
        <Typography variant="p" gutterBottom>
          No options
        </Typography>
      ) : (
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableBody>
            {props.options.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <OptionPreview
                    option={row}
                    lang={props.lang}
                    optionClickHandler={() => {}}
                    question={props.question}
                  />
                </TableCell>
                <TableCell align="right">
                  <Iconify
                    icon="eva:edit-2-outline"
                    onClick={() => props.editOptionHandler(index)}
                    sx={{ cursor: "pointer", margin: 3 }}
                  />
                  <Iconify
                    icon="eva:trash-2-outline"
                    onClick={() => {
                      setOpenConfirm(true);
                      setQuestionIndex(index);
                    }}
                    sx={{ cursor: "pointer", margin: 3 }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <DeleteDialog
        openConfirm={openConfirm}
        setOpenConfirm={setOpenConfirm}
        questionIndex={questionIndex}
        deleteGameHandler={props.deleteOptionHandler}
        type={"option"}
      />
    </>
  );
}
